import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { captureSignupAttribution } from './signupAttribution';

/**
 * Keeps UTM parameters, fbclid or the footer marker from the address on every
 * navigation, for the `sign_up` event (see signupAttribution.js). Renders
 * nothing; client-only, since effects do not run on the server.
 *
 * @returns {null}
 */
const SignupAttributionCapture = () => {
  const { search } = useLocation();
  useEffect(() => {
    captureSignupAttribution(search);
  }, [search]);
  return null;
};

export default SignupAttributionCapture;
